export default "__VITE_ASSET__KjrE1ydD__";